import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Poll } from 'src/app/models/poll.model';
import { BaseService } from '../../base/base.service';
import { PollVote } from './../../../models/poll-vote.model';

@Injectable({
  providedIn: 'root'
})
export class PollsService extends BaseService<Poll> {
  hasUnreadMessagesChanges = new BehaviorSubject<boolean>(false);
  constructor(protected http: HttpClient) {
    super(http, 'polls');
  }

  retrievePolls(
    id: number | string | undefined
  ): Observable<HttpResponse<Poll>> {
    return this.http.get<Poll>(`${this.resourceUrl}/${id}`, {
      observe: 'response'
    });
  }

  voteOnPoll(body: PollVote): Observable<HttpResponse<any>> {
    return this.http.post<any>(`${this.resourceUrl}/vote`, body, {
      observe: 'response'
    });
  }
}
